export interface WindowLike {
  id?: string;
  weekday: number;
  start_minute: number;
  end_minute: number;
}

export interface OverlapError {
  weekday: number;
  firstId?: string;
  secondId?: string;
  firstStart: number;
  firstEnd: number;
  secondStart: number;
  secondEnd: number;
}

export interface WorkScheduleWindowShape {
  id: string;
  weekday: number;
  start_minute: number;
  end_minute: number;
}

export function computeOverlapErrors(windows: ReadonlyArray<WorkScheduleWindowShape>): OverlapError[] {
  return validateWindowOverlap(windows);
}

export function validateWindowOverlap(windows: ReadonlyArray<WindowLike>): OverlapError[] {
  const byWeekday = new Map<number, WindowLike[]>();
  for (const w of windows) {
    const list = byWeekday.get(w.weekday) ?? [];
    list.push(w);
    byWeekday.set(w.weekday, list);
  }

  const errors: OverlapError[] = [];
  for (const [weekday, list] of byWeekday) {
    const sorted = [...list].sort((a, b) => a.start_minute - b.start_minute);
    for (let i = 1; i < sorted.length; i++) {
      const prev = sorted[i - 1];
      const cur = sorted[i];
      if (cur.start_minute < prev.end_minute) {
        errors.push({
          weekday,
          firstId: prev.id,
          secondId: cur.id,
          firstStart: prev.start_minute,
          firstEnd: prev.end_minute,
          secondStart: cur.start_minute,
          secondEnd: cur.end_minute,
        });
      }
    }
  }
  return errors;
}
